import React from 'react';
import { Linkedin, Youtube } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-950 border-t border-slate-800/50 pt-16 pb-8">
      <div className="container mx-auto px-4">
        {/* Top Section with 4 Columns */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Column 1 - Brand & Description */}
          <div className="space-y-6">
            <a href="/">
              <img
                src="/images/logo.png"
                alt="Samvedanam Logo"
                className="h-10 md:h-12 w-auto object-contain mb-4"
              />
            </a>
            <p className="text-slate-400 text-base leading-relaxed">
              Your trusted integrated growth advisory partner for sustainable business growth and strategic capital solutions across India and beyond.
            </p>
          </div>

          {/* Column 2 - Company */}
          <div className="space-y-6">
            <h4 className="text-white text-lg font-bold uppercase tracking-wider mb-2">Company</h4>
            <ul className="space-y-3">
              <li><a href="/" className="text-slate-400 hover:text-amber-500 transition-colors text-base">Home</a></li>
              <li><a href="/#our-approach" className="text-slate-400 hover:text-amber-500 transition-colors text-base">Our Approach</a></li>
              <li><a href="/#our-team" className="text-slate-400 hover:text-amber-500 transition-colors text-base">Team</a></li>
              <li><a href="/careers" className="text-slate-400 hover:text-amber-500 transition-colors text-base">Careers</a></li>
            </ul>
          </div>

          {/* Column 3 - Services */}
          <div className="space-y-6">
            <h4 className="text-white text-lg font-bold uppercase tracking-wider mb-2">Services</h4>
            <ul className="space-y-3">
              <li><a href="/investment-banking/fundraising" className="text-slate-400 hover:text-amber-500 transition-colors text-base">Fundraising & Advisory</a></li>
              <li><a href="/investment-banking/mergers-acquisitions" className="text-slate-400 hover:text-amber-500 transition-colors text-base">Mergers & Acquisitions</a></li>
              <li><a href="/business-advisory" className="text-slate-400 hover:text-amber-500 transition-colors text-base">Business Advisory</a></li>
              <li><a href="/academy" className="text-slate-400 hover:text-amber-500 transition-colors text-base">Academy & Workshops</a></li>
            </ul>
          </div>

          {/* Column 4 - Connect */}
          <div className="space-y-6">
            <h4 className="text-white text-lg font-bold uppercase tracking-wider mb-2">Connect</h4>
            <ul className="space-y-3">
              <li><a href="/blog" className="text-slate-400 hover:text-amber-500 transition-colors text-base">Insights & Blog</a></li>
              <li><a href="/reports" className="text-slate-400 hover:text-amber-500 transition-colors text-base">Market Reports</a></li>
              <li><a href="/live-deals" className="text-slate-400 hover:text-amber-500 transition-colors text-base">Live Deals</a></li>
              <li><a href="/#get-in-touch" className="text-slate-400 hover:text-amber-500 transition-colors text-base">Get in Touch</a></li>
            </ul>
            <div className="flex gap-4 pt-4">
              <a
                href="https://in.linkedin.com/company/samvedanam"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 rounded-xl bg-slate-900 border border-slate-800 flex items-center justify-center transition-all hover:bg-amber-600 hover:border-amber-600 hover:scale-110 group"
              >
                <Linkedin className="h-6 w-6 text-slate-300 group-hover:text-white" />
              </a>
              <a
                href="https://www.youtube.com/channel/UCLrlB7VBjLtUkbixQJkoqeA"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 rounded-xl bg-slate-900 border border-slate-800 flex items-center justify-center transition-all hover:bg-amber-600 hover:border-amber-600 hover:scale-110 group"
              >
                <Youtube className="h-6 w-6 text-slate-300 group-hover:text-white" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar with Divider */}
        <div className="pt-8 border-t border-slate-800/50">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-center md:text-left">
            <p className="text-slate-500 text-sm">
              © 2025 SAMVEDANAM Consulting &amp; Learning Solutions Pvt. Ltd. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a
                href="/privacy-policy"
                className="text-slate-500 hover:text-amber-500 transition-colors text-sm"
              >
                Privacy Policy
              </a>
              <span className="text-slate-700 text-sm">|</span>
              <a
                href="/terms-and-conditions"
                className="text-slate-500 hover:text-amber-500 transition-colors text-sm"
              >
                Terms &amp; Conditions
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
